import { client } from "../../lib/Client";
import { useNavigate } from "react-router-dom";
import { clearActiveAccountId } from "../../lib/activeAccount";
import { MenuItem } from "@mui/material";

export const LogoutButton = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    clearActiveAccountId(); // MOVED: always clear, even if the logout request fails
    try {
      const response = await client.post(
        "auth/logout",
        {},
        {
          withCredentials: true,
        }
      );
      console.log(response);
      navigate("/");
    } catch (error) {
      console.error("Logout failed:", error);
      throw new Error("Logout failed!");
      // Optionally, you can navigate to an error page or show an error message
    }
  };
  return (
    <MenuItem onClick={handleLogout}>
      Logout
    </MenuItem>
  );
};